import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';

import { MercadoInternoMercadoriasService } from './mercado-interno-mercadorias.service';
import { MercadoInternoDefeitosService } from './mercado-interno-defeitos.service';
import { MercadoInternoVariedadesService } from './mercado-interno-variedades.service';
import { MercadoInternoClassificacaoService } from './mercado-interno-classificacao.service';
import { UnidadesMedidasService } from '../unidades-medidas/unidades-medidas.service';
import { Funcoes } from "../funcoes";
import { Global } from "../global";

declare let $, swal: any;

@Component({
  selector: 'app-mercado-interno-mercadorias-form',
  templateUrl: './mercado-interno-mercadorias-form.component.html'
})
export class MercadoInternoMercadoriasFormComponent implements OnInit {

  enviandoForm = false;
  form: FormGroup;
  formFoto: FormGroup;
  title: string;
  mercadoria: any = {};
  pageIsUpd: boolean = false;
  pageIsAdd: boolean = false;

  listIndicesConclusao = [];
  listUnidadesMedidas = [];

  iIndice;
  iItem;
  nomeIndice: string = '';
  valorIndice: string = '';
  ordemIndice = 0;
  classificar = false;

  srcFoto = '';

  carregandoTabelaDefeitos: boolean = true;
  listDefeitos = [];

  carregandoTabelaVariedades: boolean = true;
  listVariedades = [];

  carregandoTabelaIndicesClassificacao: boolean = true;
  listIndicesClassificacao = [];

  constructor(
    formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private mercadoriasService: MercadoInternoMercadoriasService,
    private _location: Location,
    public func: Funcoes,
    public global: Global,
    private mercadoriasDefeitosService: MercadoInternoDefeitosService,
    private mercadoriasVariedadesService: MercadoInternoVariedadesService,
    private mercadoriasClassificacaoService: MercadoInternoClassificacaoService,
    private unidadesMedidasService: UnidadesMedidasService
  ) {

    this.srcFoto = global.dominio_site + '/mercadorias/sem-foto.jpg';

    this.formFoto = formBuilder.group({
      foto: [],
    });

    this.form = formBuilder.group({
      id: [],
      nome_pt: ['', [
        Validators.required,
        Validators.minLength(3),
        Validators.maxLength(45)
      ]],
      tempo_emitir_cert: ['', [
        Validators.required
      ]],
      tempo_emitir_cert_mi: ['', [
        Validators.required
      ]],
      valor_taxa_class: ['', [
        Validators.required
      ]],
      valor_taxa_contrato: ['', [
        Validators.required
      ]],
      ncm: [],
      portaria0: [],
      portaria_data0: [],
      instrucao_normativa: [],
      instrucao_normativa_data: [],
      com_bl: [],
      com_packing: [],
      com_confere: [],
      gerar_laudo: [],
      qtd_classificacao: [],
      id_unidades_medidas_qtd_classificacao: [],
      classificar: [],
      tipo_aparelho: [],
      is_analise_tecnologia: [],
      gerar_certificado_mi: [],
      gerar_laudo_mi: [],
      ativa: [],
      laudo_informativo: []
    });
  }

  ngOnInit() {

    if (this.router.url.split(/\//).pop().substring(0, 3) == 'upd') {
      this.pageIsUpd = true;
    }

    if (this.router.url.split(/\//).pop().substring(0, 3) == 'add') {
      this.pageIsAdd = true;
    }

    this.unidadesMedidasService.get(null, { "exibe_na_mercadoria": "1" })
      .subscribe(
        json => {
          this.listUnidadesMedidas = [];
          for (let i in json.Payload) {
            this.listUnidadesMedidas.push({
              id_unidade: json.Payload[i].id_unidade,
              nome: json.Payload[i].nome + ' (' + json.Payload[i].sigla + ')'
            });
          }
        },
        error => {
          this.func.showErro(error.json());
        });

    this.route.params.subscribe(params => {
      let id = params['id_mercadoria'];

      if (this.pageIsAdd) {
        this.title = this.func.traduzir('front.cadastrarNovaMercadoria');
      } else if (this.pageIsUpd) {
        this.title = this.func.traduzir('front.editarMercadoria');
      } else {
        this.title = this.func.traduzir('front.visualizarMercadoria');
      }

      if (!id) {
        return;
      }

      this.mercadoriasService.getById(id, ["indices_conclusao"])
        .subscribe(
          json => {
            if (this.pageIsUpd) {
              this.title = this.func.traduzir('front.editarMercadoria') + ': ' + json.Payload[0].nome_pt;
            } else {
              this.title = this.func.traduzir('front.visualizarMercadoria') + ': ' + json.Payload[0].nome_pt;
            }

            this.listIndicesConclusao = json.Payload[0].indices_conclusao || [];
            for (let i in this.listIndicesConclusao) {
              if (!this.listIndicesConclusao[i].nome && this.listIndicesConclusao[i].nome_pt) {
                this.listIndicesConclusao[i].nome = this.listIndicesConclusao[i].nome_pt;
              }
              if (this.listIndicesConclusao[i].itens) {
                for (let j in this.listIndicesConclusao[i].itens) {
                  if (!this.listIndicesConclusao[i].itens[j].nome && this.listIndicesConclusao[i].itens[j].nome_pt) {
                    this.listIndicesConclusao[i].itens[j].nome = this.listIndicesConclusao[i].itens[j].nome_pt;
                  }
                }
              }
            }

            for (let z in json.Payload[0].portarias) {
              this.form.addControl('portaria' + z, new FormControl('portaria' + z, []));
              this.form.addControl('portaria_data' + z, new FormControl('portaria_data' + z, []));
            }

            this.mercadoria = json.Payload[0];

            if (this.mercadoria.com_foto) {
              this.srcFoto = this.global.dominio_site + '/mercadorias/' + this.mercadoria.id + '/foto.jpg';
            }

            if (this.route.snapshot.queryParams["abaindices"] == '1') {
              $('a[href="#indices_classificacao"]').tab('show');
              this.carregaTabelaVariedades();
              this.carregaTabelaDefeitos();
            }

            if (this.route.snapshot.queryParams["abadefeitos"] == '1') {
              $('a[href="#defeitos"]').tab('show');
              this.carregaTabelaDefeitos();
            }

            if (this.route.snapshot.queryParams["abavariedades"] == '1') {
              $('a[href="#variedades"]').tab('show');
              this.carregaTabelaVariedades();
            }
          },
          error => {
            this.func.showErro(error.json());
          });
    });
  }

  modalAddIndiceConclusao() {
    this.nomeIndice = '';
    this.classificar = false;
    $('#modalAddIndice').modal('show');
  }

  addIndiceConclusao() {
    this.listIndicesConclusao.push({
      id_indice: null,
      id_mercadoria: null,
      itens: [],
      nome: (this.nomeIndice || '').toUpperCase(),
      classificar: this.classificar,
      ordem: this.listIndicesConclusao.length
    });
    this.nomeIndice = '';
    this.classificar = false;
    $('#modalAddIndice').modal('hide');
  }

  modalUpdIndice(iIndice) {
    this.iIndice = iIndice;
    this.nomeIndice = (this.listIndicesConclusao[this.iIndice].nome || '').toUpperCase();
    this.classificar = this.listIndicesConclusao[this.iIndice].classificar;
    $('#modalUpdIndice').modal('show');
  }

  updIndiceConclusao() {
    this.listIndicesConclusao[this.iIndice].nome = (this.nomeIndice || '').toUpperCase();
    this.listIndicesConclusao[this.iIndice].classificar = this.classificar;
    $('#modalUpdIndice').modal('hide');
  }

  deleteIndice(iIndice) {
    let self = this;
    swal({
      title: this.func.traduzir('front.voceTemCerteza'),
      text: this.func.traduzir('front.desejaDeletarIndiceConclusao'),
      type: "warning",
      showCancelButton: true,
      confirmButtonClass: 'btn-danger',
      confirmButtonText: this.func.traduzir('front.confirmar'),
      cancelButtonText: this.func.traduzir('front.cancelar'),
      closeOnConfirm: true
    },
      function () {
        self.listIndicesConclusao.splice(iIndice, 1);
      });
  }

  modalAddItemIndice(indice) {
    this.iIndice = indice;
    this.nomeIndice = '';
    this.valorIndice = '';
    $('#modalAddItemIndice').modal('show');
  }

  addItemIndiceConclusao() {
    this.listIndicesConclusao[this.iIndice].itens.push({
      id_indice: this.listIndicesConclusao[this.iIndice].id_indice,
      id_item: null,
      nome: (this.nomeIndice || '').toUpperCase(),
      valor: (this.valorIndice || '').toUpperCase(),
      ordem: this.listIndicesConclusao[this.iIndice].itens.length,
      ordem_classificacao: this.ordemIndice
    });
    this.iIndice = null;
    this.nomeIndice = '';
    this.valorIndice = '';
    this.ordemIndice = 0;
    $('#modalAddItemIndice').modal('hide');
  }

  modalUpdItemIndice(iIndice, iItem) {
    this.iIndice = iIndice;
    this.iItem = iItem;
    this.nomeIndice = (this.listIndicesConclusao[this.iIndice].itens[iItem].nome || '').toUpperCase();
    this.valorIndice = (this.listIndicesConclusao[this.iIndice].itens[iItem].valor || '').toUpperCase();
    this.ordemIndice = this.listIndicesConclusao[this.iIndice].itens[iItem].ordem_classificacao;
    $('#modalUpdItemIndice').modal('show');
  }

  updItemIndiceConclusao() {
    this.listIndicesConclusao[this.iIndice]['itens'][this.iItem] = {
      id_indice: this.listIndicesConclusao[this.iIndice].id_indice,
      id_item: this.listIndicesConclusao[this.iIndice]['itens'][this.iItem].id_item,
      nome: (this.nomeIndice || '').toUpperCase(),
      valor: (this.valorIndice || '').toUpperCase(),
      ordem: this.listIndicesConclusao[this.iIndice]['itens'][this.iItem].ordem,
      ordem_classificacao: this.ordemIndice
    };
    this.iIndice = null;
    this.iItem = null;
    this.nomeIndice = '';
    this.valorIndice = '';
    this.ordemIndice = 0;
    $('#modalUpdItemIndice').modal('hide');
  }

  deleteItemIndice(iIndice, iItem) {
    let self = this;
    swal({
      title: this.func.traduzir('front.voceTemCerteza'),
      text: this.func.traduzir('front.desejaDeletarItemIndiceConclusao'),
      type: "warning",
      showCancelButton: true,
      confirmButtonClass: 'btn-danger',
      confirmButtonText: this.func.traduzir('front.confirmar'),
      cancelButtonText: this.func.traduzir('front.cancelar'),
      closeOnConfirm: true
    },
      function () {
        self.listIndicesConclusao[iIndice]['itens'].splice(iItem, 1);
      });
  }

  voltar() {
    this._location.back();
  }

  save() {
    if (this.mercadoria.ncm && typeof this.mercadoria.ncm === 'string') {
      this.mercadoria.ncm = this.mercadoria.ncm.toUpperCase();
    }
    this.mercadoria['indices_conclusao'] = this.listIndicesConclusao;
    let result, values = this.mercadoria;
    this.enviandoForm = true;

    if (values.id) {
      result = this.mercadoriasService.editar(values, values.id);
    } else {
      result = this.mercadoriasService.adicionar(values);
    }

    result.subscribe(data => this.router.navigate(['/painel', 'mercado-interno-mercadorias']),
      error => {
        let json = error.json();
        this.func.showErro(json);
        this.enviandoForm = false;
        for (let i in json.Message.ErrorInput) {
          let erro = {};
          erro[i] = json.Message.ErrorInput[i];
          this.form.controls[i].setErrors(erro);
        }
      });
  }

  uploadFotoComplete(resp) {
    try {
      let json = JSON.parse(resp);
      if (json.Success) {
        this.srcFoto = this.global.dominio_site + '/mercadorias/' + this.mercadoria.id + '/foto.jpg?t=' + new Date().getTime();
        this.mercadoria.com_foto = true;
      }
    }
    catch (e) { }
  }

  apagaFoto() {
    let self = this;
    swal({
      title: this.func.traduzir('front.voceTemCerteza'),
      text: this.func.traduzir('front.desejaDeletarFoto'),
      type: "warning",
      showCancelButton: true,
      confirmButtonClass: 'btn-danger',
      confirmButtonText: this.func.traduzir('front.confirmar'),
      cancelButtonText: this.func.traduzir('front.cancelar'),
      closeOnConfirm: true
    },
      function () {
        self.mercadoriasService.apagarFoto(self.mercadoria.id)
          .subscribe(
            json => {
              if (json.Success) {
                self.srcFoto = self.global.dominio_site + '/mercadorias/sem-foto.jpg';
                self.mercadoria.com_foto = false;
              }
            },
            error => {
              self.func.showErro(error.json());
            });
      });
  }

  carregaTabelaDefeitos() {
    let id = this.mercadoria.id || (this.route.snapshot ? this.route.snapshot.params['id_mercadoria'] : null);
    if (id) {
      this.carregandoTabelaDefeitos = true;
      this.mercadoriasDefeitosService.get(['unidade_medida'], { "id_mercadoria": id })
        .subscribe(data => {
          this.listDefeitos = data['Payload'];
          this.carregandoTabelaDefeitos = false;
        },
          error => {
            this.func.showErro(error.json());
            this.carregandoTabelaDefeitos = false;
          });
    }
  }

  deleteDefeito(defeito) {
    let defeitos = this.listDefeitos;
    let mercadoriasDefeitosService = this.mercadoriasDefeitosService;
    let self = this;

    swal({
      title: this.func.traduzir('front.voceTemCerteza'),
      text: this.func.traduzir('front.desejaDeletarDefeito') + defeito.nome_pt,
      type: "warning",
      showCancelButton: true,
      confirmButtonClass: 'btn-danger',
      confirmButtonText: this.func.traduzir('front.confirmar'),
      cancelButtonText: this.func.traduzir('front.cancelar'),
      closeOnConfirm: true
    },
      function () {
        let index = defeitos.indexOf(defeito);
        defeitos.splice(index, 1);
        mercadoriasDefeitosService.apagar(defeito.id)
          .subscribe(res => {
            self.listDefeitos = defeitos;
          },
            err => {
              defeitos.splice(index, 0, defeito);
              self.listDefeitos = defeitos;
              self.func.showErro(err.json());
            });
      });
  }

  carregaTabelaVariedades() {
    let id = this.mercadoria.id || (this.route.snapshot ? this.route.snapshot.params['id_mercadoria'] : null);
    if (id) {
      this.carregandoTabelaVariedades = true;
      this.mercadoriasVariedadesService.get(null, { "id_mercadoria": id })
        .subscribe(data => {
          this.listVariedades = data['Payload'];
          this.carregandoTabelaVariedades = false;
        },
          error => {
            this.func.showErro(error.json());
            this.carregandoTabelaVariedades = false;
          });
    }
  }

  deleteVariedade(variedade) {
    let variedades = this.listVariedades;
    let mercadoriasVariedadesService = this.mercadoriasVariedadesService;
    let self = this;

    swal({
      title: this.func.traduzir('front.voceTemCerteza'),
      text: this.func.traduzir('front.desejaDeletarMercadoriaVariedade') + variedade.nome,
      type: "warning",
      showCancelButton: true,
      confirmButtonClass: 'btn-danger',
      confirmButtonText: this.func.traduzir('front.confirmar'),
      cancelButtonText: this.func.traduzir('front.cancelar'),
      closeOnConfirm: true
    },
      function () {
        let index = variedades.indexOf(variedade);
        variedades.splice(index, 1);
        mercadoriasVariedadesService.apagar(variedade.id)
          .subscribe(res => {
            self.listVariedades = variedades;
          },
            err => {
              variedades.splice(index, 0, variedade);
              self.listVariedades = variedades;
              self.func.showErro(err.json());
            });
      });
  }

  ordenouIndicesConclusao(e) {
    for (let i in this.listIndicesConclusao) {
      this.listIndicesConclusao[i].ordem = parseInt(i) + 1;
    }
  }

  ordenouItensIndicesConclusao(e, indiceConclusao) {
    for (let i in this.listIndicesConclusao[indiceConclusao].itens) {
      this.listIndicesConclusao[indiceConclusao].itens[i].ordem = parseInt(i);
    }
  }

  addPortaria() {
    if (!this.mercadoria.portarias) {
      this.mercadoria.portarias = [];
    }
    this.form.addControl('portaria' + this.mercadoria.portarias.length, new FormControl('portaria' + this.mercadoria.portarias.length, []));
    this.form.addControl('portaria_data' + this.mercadoria.portarias.length, new FormControl('portaria_data' + this.mercadoria.portarias.length, []));
    this.mercadoria.portarias.push({ "portaria": null, "portaria_data": null });
  }

  removePortaria(i) {
    this.mercadoria.portarias.splice(i, 1);
  }

  ordenouDefeitos(e) {
    for (let i in this.listDefeitos) {
      this.listDefeitos[i].ordem = parseInt(i) + 1;
    }
    this.mercadoriasDefeitosService.ordenaIndices(this.listDefeitos)
      .subscribe(json => { });
  }

  validateForm(form) {
    for (let i in form['controls']) {
      this.form['controls'][i].markAsTouched();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/mercado-interno-mercadorias/mercado-interno-mercadorias-form.component.ts